module.exports = __webpack_public_path__ + "img/about-bg.26e269b8.png";